import {
  Container,
  Grid,
  BackgroundImage,
  Center,
  Overlay,
  Box,
  Title,
  Text
} from '@mantine/core'
import logoWhite from '../../assets/logos/AI Analytics logo (white).svg'

export function AuthLayout({ children, title, subtitle }) {
  return (
    <Container size="100%" h={{ base: 'auto', md: '100vh' }} p={0}>
      <Grid h={{ base: 'auto', md: '100vh' }} m={0} gutter={0}>
        {/* Left side with image and branding */}
        <Grid.Col
          span={{ base: 12, md: 6 }}
          h={{ base: 'auto', md: '100vh' }}
          pos="relative"
        >
          <BackgroundImage
            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=2070"
            h="100%"
            style={{ minHeight: '300px' }}
          >
            <Overlay color="#000" opacity={0.5} />
            <Center h="100%" p={{ base: 'lg', md: 'xl' }} pos="relative" style={{ zIndex: 201 }}>
              <Box>
                <Box mb="xl">
                  <img
                    src={logoWhite}
                    alt="AI Analytics"
                    height="50"
                    width="auto"
                  />
                </Box>

                <Title order={1} c="white" size="3rem" mb="md">
                  {title || 'Improve your skill with AI Analytics!'}
                </Title>

                <Text c="white" size="lg" opacity={0.9}>
                  {subtitle || 'Adaptive learning platform that identifies knowledge gaps and ensures true competency through personalized assessment and targeted training.'}
                </Text>
              </Box>
            </Center>
          </BackgroundImage>
        </Grid.Col>

        {/* Right side with form */}
        <Grid.Col 
          span={{ base: 12, md: 6 }}
          h={{ base: 'auto', md: '100vh' }}
          style={{ overflowY: 'auto' }}
        >
          <Center mih="100%" p="xl">
            <Box w="100%" maw={400}>
              {children}
            </Box>
          </Center>
        </Grid.Col>
      </Grid>
    </Container>
  )
}

export default AuthLayout